import { Checkbox } from '@m/alchemy-ui/Checkbox';

import * as Styled from './AreaOfExcellenceCheckbox.styled';

export function AreaOfExcellenceCheckbox({
  label,
  isChecked = false,
  onChange = () => {},
  disabled: rawDisabled = false,
}: AreaOfExcellenceCheckboxProps) {
  const disabled = isChecked ? false : rawDisabled;

  return (
    <Styled.AreaOfExcellenceContainer checked={isChecked} disabled={disabled}>
      <Checkbox
        label={label}
        checked={isChecked}
        onChange={onChange}
        disabled={disabled}
      />
    </Styled.AreaOfExcellenceContainer>
  );
}

interface AreaOfExcellenceCheckboxProps {
  label: string;
  isChecked?: boolean;
  onChange?: () => void;
  disabled?: boolean;
}
